import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GoalTypeEnum } from 'src/app/enums/goal-type.enum';
import { GoalPermissionsHelper } from 'src/app/helpers/goal-permissions.helper';
import { GoalPeriod } from 'src/app/models/goalperiod.model';
import { GoalText } from 'src/app/models/goaltext.model';
import { GroupGoal, GroupGoalModel } from 'src/app/models/group-goal.model';
import { GroupGoalsData } from 'src/app/models/group-goals-data.model';
import { State } from 'src/app/models/state.model';
import { GoalService, StateService } from 'src/app/services';
import { GroupGoalService } from 'src/app/services/group-goal.service';
import { ErrorMessageService } from 'src/app/shared/services';

@Component({
  selector: 'app-group-goal-edit',
  templateUrl: './group-goal-edit.component.html',
  styleUrls: ['./group-goal-edit.component.scss']
})
export class GroupGoalEditComponent implements OnInit {
  
  @Input()
  public groupGoal: GroupGoal;

  @Input()
  public goalPeriod: GoalPeriod;

  @Input()
  public data: GroupGoalsData;

  @Output()
  public delete = new EventEmitter<number>();

  public goalTextId?: number;
  public name: string;
  public parentGroupGoalId?: number;
  public state: State;

  constructor(
    private groupGoalService: GroupGoalService,
    private goalService: GoalService,
    stateService: StateService,
    private msgService: ErrorMessageService,
    private translate: TranslateService) {
        this.state = stateService.state;
    }

  ngOnInit(): void {
    this.name = this.groupGoal.name;
    this.goalTextId = this.groupGoal.goalTextId;
	
  }

//   addGroupGoal() {

//     let model = new GroupGoalModel();
//     model.name = this.name;
//     //model.goalText.goalType = GoalTypeEnum.GroupGoal;
//     model.goalPeriodId = this.data.goalPeriodId;
//     model.parentGroupGoalId = this.parentGroupGoalId;

//     this.groupGoalService.addGroupGoal(model).subscribe((groupGoal) => {
//         this.data.loading = false;
//         this.added.emit(groupGoal);
//     }, (error) => {
//         console.log(error);
//         this.data.loading = false;
//     });        
// };

    allowEdit(): boolean {
        return GoalPermissionsHelper.canGroupGoalFieldsEdit(this.goalPeriod, this.state);
    }

    allowDelete(): boolean {
        return GoalPermissionsHelper.canGroupGoalDelete(this.goalPeriod, this.state);
    }

    deleteGroupGoal() {
        if (this.groupGoal.id == 0)
        {
            this.delete.emit(this.groupGoal.id);
            return;
        }

        if (confirm(this.translate.instant("GENERAL.DELETE_CONFIRM"))) {
            this.groupGoalService.deleteGroupGoal(this.groupGoal.id).subscribe({
                next: (result) => {
                    this.delete.emit(this.groupGoal.id);
                },
                error: (e) => {
                    
                    this.msgService.showSnackBarError('A csapatcél nem törölhető mert már létezik hozzá kapcsolódó cél vagy csapatcél!', 7000);
                },
                complete: () => {} 
            });
        }
    };

    groupGoalChanged(e: any) {    
        //this.saveGroupGoal();
    }

    parentGroupGoalChanged(parentGroupGoal: GroupGoal) {
        if (!parentGroupGoal)
        {
            //this.parentGroupGoalId = null;
            this.groupGoal.parentGroupGoalId = null;
        }
        else
        {
            //this.parentGroupGoalId = parentGroupGoal.id;
            this.groupGoal.parentGroupGoalId = parentGroupGoal.id;
        }

        //this.saveGroupGoal();
    }


}
